<template>
  <div class="mt-2">
    <label for="gender-selector" class="block text-sm font-medium text-gray-700">Género</label>
    <a-select
      id="gender-selector"
      :default-value="internalValue"
      @change="onUpdate"
      class="mt-1 block w-full"
      placeholder="Selecciona un género"
      show-search
      option-filter-prop="label"
      :filter-option="filterOption"
    >
      <a-select-option v-for="(gender, index) in genders" :key="index" :value="gender.code" :label="gender.name">
        {{ gender.icon }} {{ gender.name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Object,
      default: () => ({ code: '', name: '', icon: '' })
    }
  },
  computed: {
    internalValue () {
      return this.value.code || null
    }
  },
  data () {
    return {
      genders: [
        { code: 'male', name: 'Masculino', icon: '👨' },
        { code: 'female', name: 'Femenino', icon: '👩' },
        { code: 'non_binary', name: 'No binario', icon: '⚧' },
        { code: 'prefer_not_to_say', name: 'Prefiero no decir', icon: '🤐' },
        { code: 'other', name: 'Otro', icon: '🌈' }
        // Puedes añadir más opciones de género aquí
      ]
    }
  },
  methods: {
    onUpdate (value) {
      const selectedRecord = this.genders.find(record => record.code === value)
      selectedRecord.nameIcon = selectedRecord.icon + ' ' + selectedRecord.name
      this.$emit('change', selectedRecord)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style scoped>
/* Puedes añadir estilos adicionales aquí si es necesario */
</style>
